module.exports = __webpack_public_path__ + "static/media/imc.5e6f4267.webp";